(function ($, window, document, undefined) {

Navigation = ( function() {

	function Constructor() {

		this.start = function () {

			$( '.toggle-close' ).click( function () {
				$( '#header' ).toggleClass( 'open' );
				$( '.nav-bg' ).toggleClass( 'open' );
				$( '.nav-drawer' ).toggleClass( 'open' );
				$( 'body' ).toggleClass( 'toggled' );
			} );

			$( '.menu-toggle' ).click( function () {
				$( '#header' ).toggleClass( 'open' );
				$( '.nav-bg' ).toggleClass( 'open' );
				$( '.nav-drawer' ).toggleClass( 'open' );
				$( 'body' ).toggleClass( 'toggled' );
			} );

			// $( '.nav-drawer a, .nav-drawer .menu-toggle' ).click( function () {
			// 	$( '.nav-bg' ).removeClass( 'open' );
			// 	$( '.nav-drawer' ).removeClass( 'open' );
			// 	$( 'body' ).removeClass( 'toggled' );
			// } );

			$( '.nav-drawer li.menu-item-has-children a' ).click( function (e) {
				e.preventDefault();
				$( this ).next().toggleClass( 'activated' );
				return false;
			} );

		};

	}
	return new Constructor();

}() );

})(jQuery, window, document);
